import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=70464170&scoped=true&"
import script from "./chart.vue?vue&type=script&lang=js&"
export * from "./chart.vue?vue&type=script&lang=js&"
import style0 from "./chart.vue?vue&type=style&index=0&id=70464170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70464170",
  null
  
)

export default component.exports